// extracted by mini-css-extract-plugin
module.exports = {"root":"StyledList_root__LxDqR","promiseStyle":"StyledList_promiseStyle__x7liJ"};